/* tslint:disable */
/* eslint-disable */
export enum LaborCostGroupType {
  Task = 'task',
  Labor = 'labor',
  Budget = 'budget',
  CostType = 'costType'
}
